/**
 * Story posts live in the same `posts` table as feed posts, but they must
 * never surface on the Posts board (Bozza/Tutti stages). The dedicated
 * Stories board fetches them via `post_type=story`.
 *
 * Pure + dependency-free so it can be unit-tested without pulling in the
 * hook's heavy transitive imports (axios, the query client, etc.). Generic
 * over the `postType` carrier so it works on both `PostItem` (raw query
 * data) and the legacy `Post` shape.
 */
export const excludeStories = <T extends { postType: string }>(
  posts: T[],
): T[] => posts.filter((p) => p.postType !== "story");
